import { gql } from '@apollo/client';

export default gql`
  query GetAdvisorSystemLog($advisor_id: Int!) {
    getAdvisorSystemLog(advisor_id: $advisor_id) {
      id
      advisor_id
      provider_id
      provider_name
      recipient_email
      mail_from
      action_type
      status
      process_status
      scheduled_at
      executed_at
      cancelled_at
      cancel_reason
      triggered_by
      triggered_by_name
      mail_content
      is_manual_edit
      createdAt
      current_subject
      error_reason
      error_detail
      history {
        id
        entry_type
        mail_subject_snapshot
        mail_content_snapshot
        scheduled_at
        triggered_by
        triggered_by_name
        createdAt
      }
    }
  }
`;
